(function () {
  "use strict";
  function domLiteMode() {
    return document.documentElement.hasAttribute("data-sf-hp-lite");
  }
  var CTA_BASE = "Last Longer";
  function createArrow() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    (svg.setAttribute("viewBox", "0 0 24 24"),
      svg.setAttribute("fill", "none"),
      svg.setAttribute("stroke", "currentColor"),
      svg.setAttribute("stroke-width", "2"),
      svg.setAttribute("stroke-linecap", "round"),
      svg.setAttribute("stroke-linejoin", "round"),
      svg.setAttribute("width", "18"),
      svg.setAttribute("height", "18"),
      svg.setAttribute("aria-hidden", "true"));
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    return (
      path.setAttribute("d", "M5 12h14M13 5l7 7-7 7"),
      svg.appendChild(path),
      svg
    );
  }
  function setAtcWithArrow(btn, line) {
    if (btn) {
      var text = (line || CTA_BASE).replace(/\s+/g, " ").trim();
      ((btn.textContent = text + " "), btn.appendChild(createArrow()));
    }
  }
  function setStickyCtaText(btn, price) {
    if (btn) {
      var t = "Add to cart";
      (price && (t += " \u2014 " + price), (btn.textContent = t));
    }
  }
  function syncActivePlanCTA() {
    var row = document.querySelector(".sf-buy__row.is-active"),
      atc = document.getElementById("sf-atc-btn"),
      sticky = document.getElementById("sf-sticky-atc-btn"),
      meta = document.getElementById("sf-sticky-meta");
    if (row) {
      var price = row.getAttribute("data-price") || "",
        sub = (row.getAttribute("data-sf-sticky-meta") || "").replace(
          /&amp;/g,
          "&",
        ),
        withPrice = price ? CTA_BASE + " \u2014 " + price : CTA_BASE;
      (setAtcWithArrow(atc, withPrice),
        setStickyCtaText(sticky, price),
        meta && sub && (meta.textContent = sub));
    }
  }
  function initCountdown() {
    var el = document.getElementById("sf-timer");
    if (!el) return;
    var HOURS = 8,
      key = "sf-deadline-2025",
      stored = parseInt(localStorage.getItem(key) || "0", 10);
    (!stored || stored <= Date.now()) &&
      ((stored = Date.now() + HOURS * 3600 * 1e3),
      localStorage.setItem(key, String(stored)));
    function tick() {
      var rem = stored - Date.now();
      rem < 0 && (rem = 0);
      var h = Math.floor(rem / 36e5),
        m = Math.floor((rem % 36e5) / 6e4),
        s = Math.floor((rem % 6e4) / 1e3);
      el.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
    }
    function pad(n) {
      return String(n).padStart(2, "0");
    }
    (tick(), setInterval(tick, 1e3));
  }
  function initHeader() {
    var header = document.querySelector(".sf-header");
    if (!header) return;
    function onScroll() {
      header.classList.toggle("is-scrolled", window.scrollY > 20);
    }
    (window.addEventListener("scroll", onScroll, { passive: !0 }), onScroll());
  }
  function initMobileNav() {
    var toggle = document.getElementById("sf-nav-toggle"),
      nav = document.getElementById("sf-mobile-nav");
    !toggle ||
      !nav ||
      (toggle.addEventListener("click", function () {
        var open = nav.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", String(open));
      }),
      nav.querySelectorAll("a").forEach(function (a) {
        a.addEventListener("click", function () {
          nav.classList.remove("is-open");
        });
      }));
  }
  function initFaq() {
    var items = document.querySelectorAll(".sf-faq__item");
    items.forEach(function (item) {
      var btn = item.querySelector(".sf-faq__q");
      btn &&
        btn.addEventListener("click", function () {
          var isOpen = item.classList.contains("is-open");
          (items.forEach(function (i) {
            i.classList.remove("is-open");
          }),
            isOpen || item.classList.add("is-open"));
        });
    });
  }
  function initGallery() {
    var mainImg = document.getElementById("sf-product-hero-img"),
      thumbs = document.querySelectorAll(".sf-product__thumb");
    !mainImg ||
      !thumbs.length ||
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var src = thumb.dataset.src;
          (src && (mainImg.src = src),
            thumbs.forEach(function (t) {
              t.classList.remove("is-active");
            }),
            thumb.classList.add("is-active"));
        });
      });
  }
  function initPlanSelector() {
    var rows = document.querySelectorAll(".sf-buy__row");
    rows.length &&
      (rows.forEach(function (row) {
        row.addEventListener("click", function () {
          (rows.forEach(function (r) {
            r.classList.remove("is-active");
          }),
            row.classList.add("is-active"),
            syncActivePlanCTA());
        });
      }),
      syncActivePlanCTA());
  }
  function initAddToCart() {
    document.querySelectorAll("[data-sf-atc]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var activeRow = document.querySelector(".sf-buy__row.is-active"),
          variantId = activeRow
            ? activeRow.dataset.variantId
            : btn.dataset.variantId,
          sellingPlanId = activeRow ? activeRow.dataset.sellingPlanId : null,
          discountCode = activeRow ? activeRow.dataset.discountCode : "",
          qtyParsed =
            activeRow && activeRow.dataset.quantity
              ? parseInt(activeRow.dataset.quantity, 10)
              : 1,
          quantity = qtyParsed >= 1 && qtyParsed <= 99 ? qtyParsed : 1;
        if (!variantId) {
          var firstRow = document.querySelector(
            '.sf-buy__row[data-variant-id]:not([data-variant-id=""])',
          );
          if (
            ((variantId = firstRow ? firstRow.dataset.variantId : null),
            firstRow && firstRow.dataset.quantity)
          ) {
            var fq = parseInt(firstRow.dataset.quantity, 10);
            fq >= 1 && fq <= 99 && (quantity = fq);
          }
        }
        if (variantId) {
          btn.classList.add("is-loading");
          window.location.assign(
            "/cart/" +
              encodeURIComponent(variantId) +
              ":" +
              encodeURIComponent(quantity) +
              (discountCode
                ? "?discount=" + encodeURIComponent(discountCode) + "&checkout"
                : "?checkout"),
          );
        }
      });
    });
  }
  function initStickyATC() {
    var bar = document.getElementById("sf-sticky-bar"),
      hero = document.querySelector(".sf-hero");
    hero || (hero = document.getElementById("sf-product"));
    var footer = document.querySelector(".sf-footer");
    if (!bar || !hero) return;
    var pending;
    function update() {
      var heroR = hero.getBoundingClientRect();
      if (heroR.bottom > 0) {
        bar.classList.remove("is-visible");
        return;
      }
      if (footer) {
        var fr = footer.getBoundingClientRect(),
          vh = document.documentElement.clientHeight;
        if (fr.top < vh) {
          bar.classList.remove("is-visible");
          return;
        }
      }
      bar.classList.add("is-visible");
    }
    function onScroll() {
      pending ||
        (pending = requestAnimationFrame(function () {
          ((pending = null), update());
        }));
    }
    (window.addEventListener("scroll", onScroll, { passive: !0 }),
      window.addEventListener("resize", onScroll, { passive: !0 }),
      onScroll());
  }
  function initProblemBignum() {
    var sec = document.querySelector("[data-sf-problem]"),
      el = document.querySelector("[data-sf-problem-bignum]");
    if (!(!sec || !el)) {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        el.classList.add("is-animated");
        return;
      }
      if (!window.IntersectionObserver) {
        el.classList.add("is-animated");
        return;
      }
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            e.isIntersecting &&
              (el.classList.add("is-animated"), obs.unobserve(sec));
          });
        },
        { threshold: 0.15 },
      );
      obs.observe(sec);
    }
  }
  function initStudySection() {
    var section = document.querySelector("[data-sf-study]"),
      fill = document.querySelector("[data-sf-study-fill]"),
      counter = document.querySelector("[data-sf-study-counter]");
    if (!(!section || !fill || !counter || !window.IntersectionObserver)) {
      var done = !1,
        obs = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting || done) return;
              ((done = !0),
                obs.unobserve(e.target),
                (fill.style.width = "90%"),
                (fill.style.transition =
                  "width 1.6s cubic-bezier(0.22, 1, 0.36, 1)"));
              var target = 496,
                t0 = performance.now(),
                dur = 1600;
              function step(now) {
                var p = Math.min(1, (now - t0) / dur),
                  ease = 1 - Math.pow(1 - p, 1.2);
                ((counter.textContent = String(Math.round(ease * target))),
                  p < 1 && requestAnimationFrame(step));
              }
              requestAnimationFrame(step);
            });
          },
          { threshold: 0.12 },
        );
      obs.observe(section);
    }
  }
  function runBaValCount(el, targetNum, durationMs) {
    if (!el) return;
    var t0 = performance.now(),
      dur = durationMs != null ? durationMs : 1e3;
    function step(now) {
      var p = Math.min(1, (now - t0) / dur),
        ease = 1 - Math.pow(1 - p, 1.2);
      ((el.textContent = String(Math.round(ease * targetNum))),
        p < 1 && requestAnimationFrame(step));
    }
    requestAnimationFrame(step);
  }
  function initBarAnimations() {
    var bars = document.querySelectorAll(".sf-ba__bar .fill");
    if (!(!bars.length || !window.IntersectionObserver)) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var bar = entry.target,
                w = bar.getAttribute("data-target-width") || bar.style.width;
              w && (bar.style.width = w);
              var row = bar.closest(".sf-ba__bar"),
                vEl = row && row.querySelector(".sf-ba__val-num");
              if (vEl) {
                var n = parseInt(vEl.getAttribute("data-sf-ba-val") || "0", 10);
                n && runBaValCount(vEl, n, 1e3);
              }
              observer.unobserve(bar);
            }
          });
        },
        { threshold: 0.2 },
      );
      bars.forEach(function (bar) {
        var target = bar.getAttribute("data-target-width") || bar.style.width;
        target &&
          (bar.setAttribute("data-target-width", target),
          (bar.style.width = "0"),
          (bar.style.transition = "width 1s var(--ease-out)"),
          observer.observe(bar));
      });
    }
  }
  function initHeroStatic() {
    if (!domLiteMode()) {
      var labels = document.querySelectorAll("[data-sf-clock-step]");
      labels.length &&
        labels.forEach(function (label) {
          var step = label.getAttribute("data-sf-clock-step");
          label.classList.toggle("is-active", step === "1");
        });
    }
  }
  function initHeroGsapDesktop() {
    if (!domLiteMode()) {
      var heroEl = document.getElementById("sf-hero");
      if (
        !(heroEl && heroEl.getAttribute("data-sf-hero-gsap") === "false") &&
        !(typeof gsap == "undefined" || !window.ScrollTrigger) &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) {
        gsap.registerPlugin(ScrollTrigger);
        var spinDeg = 720;
        if (heroEl) {
          var raw = heroEl.getAttribute("data-sf-hero-spin"),
            parsed = raw ? parseFloat(raw) : NaN;
          !isNaN(parsed) && parsed > 0 && (spinDeg = parsed);
        }
        var mm = gsap.matchMedia();
        mm.add("(min-width: 901px)", function () {
          var visual = document.getElementById("sf-hero-visual"),
            product = document.getElementById("sf-hero-product"),
            disc = document.getElementById("sf-hero-disc"),
            burst = document.getElementById("sf-hero-burst");
          if (!visual || !product || !disc || !burst) return function () {};
          var chips = visual.querySelectorAll(".sf-hero__chip");
          (gsap.set(product, { opacity: 1 }),
            gsap.set(burst, { opacity: 1 }),
            chips.length && gsap.set(chips, { opacity: 1, x: 0 }));
          var tl = gsap.timeline({ defaults: { ease: "power3.out" } });
          (tl
            .fromTo(
              product,
              { y: -80, scale: 0.88 },
              { y: 0, scale: 1, duration: 1.2, ease: "elastic.out(1,0.6)" },
            )
            .fromTo(
              burst,
              { scale: 0, rotation: -30 },
              { scale: 1, rotation: -8, duration: 0.8, ease: "back.out(2.2)" },
              "-=0.6",
            ),
            chips.length &&
              tl.fromTo(
                chips,
                { x: 40 },
                { x: 0, duration: 0.5, stagger: 0.12 },
                "-=0.7",
              ));
          var floatTween = gsap.to(disc, {
              y: "+=10",
              duration: 3.2,
              ease: "sine.inOut",
              yoyo: !0,
              repeat: -1,
            }),
            scrollTweens = [
              gsap.to(product, {
                rotation: spinDeg,
                scale: 2.15,
                y: 240,
                x: 48,
                ease: "none",
                immediateRender: !1,
                scrollTrigger: {
                  trigger: ".sf-hero",
                  start: "top top",
                  end: "+=160%",
                  scrub: 0.4,
                },
              }),
              gsap.to(disc, {
                yPercent: 30,
                scale: 1.35,
                rotation: -90,
                ease: "none",
                immediateRender: !1,
                scrollTrigger: {
                  trigger: ".sf-hero",
                  start: "top top",
                  end: "+=160%",
                  scrub: !0,
                },
              }),
              gsap.to(burst, {
                rotation: -180,
                scale: 1.5,
                y: -60,
                ease: "none",
                immediateRender: !1,
                scrollTrigger: {
                  trigger: ".sf-hero",
                  start: "top top",
                  end: "+=160%",
                  scrub: !0,
                },
              }),
            ];
          return function () {
            (floatTween.kill(),
              tl.kill(),
              scrollTweens.forEach(function (t) {
                (t && t.scrollTrigger && t.scrollTrigger.kill(),
                  t && t.kill && t.kill());
              }));
          };
        });
      }
    }
  }
  document.addEventListener("DOMContentLoaded", function () {
    (initCountdown(),
      initHeader(),
      initMobileNav(),
      initFaq(),
      initGallery(),
      initPlanSelector(),
      initAddToCart(),
      initStickyATC(),
      initBarAnimations(),
      initStudySection(),
      initProblemBignum(),
      domLiteMode() || (initHeroStatic(), initHeroGsapDesktop()));
  });
})();
//# sourceMappingURL=/cdn/shop/t/78/assets/sf-homepage-2025.js.map?v=180617262427440501731787622270
